(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };
  const reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  const desktop = window.matchMedia ? window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)') : null;

  const initializeViewers = (root = document) => {
    root.querySelectorAll('[data-sc-story-viewer]').forEach((viewer) => {
      if (viewer.dataset.scReady) return;
      const object = viewer.querySelector('.sc-story-viewer__object');
      const original = viewer.querySelector('.softcore-product-story__image');
      const controls = viewer.querySelector('.sc-story-viewer__controls');
      const status = viewer.querySelector('[data-sc-view-label]');
      if (!object || !original || !controls || !status) return;
      viewer.dataset.scReady = 'true';
      controls.hidden = false;
      let wanted = 'art';
      const renderView = (view) => {
        const showObject = view === 'object';
        viewer.dataset.view = view;
        controls.querySelectorAll('button').forEach((control) => {
          control.setAttribute('aria-pressed', String(control.dataset.scView === view));
          control.removeAttribute('aria-busy');
        });
        original.setAttribute('aria-hidden', String(showObject));
        object.setAttribute('aria-hidden', String(!showObject));
        status.textContent = showObject ? status.dataset.objectLabel : status.dataset.artLabel;
      };
      object.addEventListener('load', () => { if (wanted === 'object') renderView('object'); });
      object.addEventListener('error', () => {
        wanted = 'art';
        renderView('art');
        status.textContent = status.dataset.errorLabel;
      });
      controls.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('button[data-sc-view]') : null;
        if (!button || !controls.contains(button)) return;
        const showObject = button.dataset.scView === 'object';
        wanted = showObject ? 'object' : 'art';
        if (showObject && !(object.complete && object.naturalWidth > 0)) {
          button.setAttribute('aria-busy', 'true');
          status.textContent = status.dataset.loadingLabel;
          object.loading = 'eager';
          return;
        }
        renderView(wanted);
      });
    });
  };

  /* Scroll work is limited to visible editorial photographs, only while moving. */
  const selector = '.sc-dept__frame, .sc-living__hero-art, .softcore-journal__image';
  const active = new Set();
  const tracked = new Set();
  let frame = 0;
  const enabled = () => reduced && desktop && !reduced.matches && desktop.matches && !document.hidden;
  const reset = (image) => {
    image.style.removeProperty('--sc-studio-drift');
    image.classList.remove('sc-studio-drift');
  };
  const update = () => {
    frame = 0;
    if (!enabled()) return;
    const height = window.innerHeight;
    active.forEach((image) => {
      if (!image.isConnected) { active.delete(image); tracked.delete(image); return; }
      const rect = image.parentElement.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - height / 2) / height));
      image.classList.add('sc-studio-drift');
      const distance = Math.min(16, rect.height * .025);
      image.style.setProperty('--sc-studio-drift', `${(progress * -distance).toFixed(2)}px`);
    });
  };
  const schedule = () => { if (enabled() && !frame) frame = requestAnimationFrame(update); };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) active.add(target);
      else { active.delete(target); reset(target); }
    });
    schedule();
  }, { rootMargin: '80px' }) : null;
  const initializeDrift = (root = document) => {
    if (!observer) return;
    root.querySelectorAll(selector).forEach((container) => {
      const image = container.querySelector('img');
      if (!image || tracked.has(image)) return;
      tracked.add(image);
      observer.observe(image);
    });
  };
  const refresh = () => {
    if (!enabled()) {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      tracked.forEach(reset);
    } else schedule();
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('visibilitychange', refresh);
  reduced?.addEventListener('change', refresh);
  desktop?.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', ({ target }) => {
    initializeViewers(target);
    initializeDrift(target);
  });
  document.addEventListener('shopify:section:unload', ({ target }) => {
    tracked.forEach((image) => {
      if (!target.contains(image)) return;
      observer?.unobserve(image);
      active.delete(image);
      tracked.delete(image);
      reset(image);
    });
  });
  ready(() => { initializeViewers(); initializeDrift(); });
})();
